// @flow
import styled from 'styled-components';

export const FormGroup = styled.div`
    display: flex;
    align-items: center;
	margin: 0.6em 0 2em 0;
`;

export default FormGroup;


// WEBPACK FOOTER //
// ./src/components/Form/FormGroup/index.js